export default "__VITE_ASSET__2394f2b1__"